<template>
    <div>
        <div class="headBtn">
            <div style="color: #f9fafc; font-size: 20px">
                <!-- <img :src="weizhi" alt="" style="height:42px;"> -->
                <span v-text-lbl="'seatLayoutSettings'">坐席布局设置</span>
            </div>
            <el-button-group>
                <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="closeSeat">关 闭</el-button>
                <el-button id="processSave" v-pageBtn-lbl="'save'" icon="el-icon-check" @click="saveSeat">保 存</el-button>
            </el-button-group>
        </div>
        <div class="seat-main">
            <div id="left" class="left">
                <ul>
                    <li class="left-li">
                        <img :src="rectPng" type="rect" alt="" style="width: 80px; height: 45px" />
                        <div v-text-lbl="'longTable'" class="mt12">长型桌子</div>
                    </li>
                    <li class="left-li">
                        <img :src="circlePng" type="circle" alt="" style="width: 80px; height: 80px" />
                        <div v-text-lbl="'circleTable'" class="mt12">圆型桌子</div>
                    </li>
                    <li class="left-li">
                        <img :src="uPng" type="utype" alt="" style="width: 80px; height: 45px" />
                        <div v-text-lbl="'uTable'" class="mt12">U型桌子</div>
                    </li>
                    <li class="left-li">
                        <img :src="bigPng" type="big" alt="" style="width: 80px; height: 69px" />
                        <div v-text-lbl="'auditorium'" class="mt12">大礼堂</div>
                    </li>
                </ul>
            </div>
            <div id="center" class="center">
                <ul class="dropdown-menu">
                    <li>
                        <a id="deleteNode" v-text-lbl="'delEle'" href="javascript:;">删除元素</a>
                    </li>
                </ul>
            </div>
            <el-form :model="rectForm" autocomplete="off" class="setForm" @submit.native.prevent>
                <div class="attr_title">
                    <span v-text-lbl="'seatSettingsWindow'">坐席设置窗口</span>
                    <i class="el-icon-close" style="float: right" @click="hideForm"></i>
                </div>
                <table border="1" class="list">
                    <tr>
                        <td v-text-lbl="'meetingRoomType'" align="right" class="tdBg" style="width: 130px">会议室类型</td>
                        <td v-if="deskType === 'circle'" v-text-lbl="'circleTable'">圆型桌子</td>
                        <td v-if="deskType === 'rect'" v-text-lbl="'longTable'">长型桌子</td>
                        <td v-if="deskType === 'utype'" v-text-lbl="'uTable'">U型桌子</td>
                        <td v-if="deskType === 'big'" v-text-lbl="'auditorium'">大礼堂</td>
                    </tr>
                    <!-- 圆桌 -->
                    <tr v-if="deskType === 'circle'">
                        <td align="right" class="tdBg" style="width: 130px">
                            <em>*</em>
                            <span v-text-lbl="'seats'">坐席</span>
                        </td>
                        <td>
                            <el-input v-model="circleSeat" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                        </td>
                    </tr>
                    <!-- 长型桌 U型桌 -->
                    <template v-if="deskType === 'rect' || deskType === 'utype'">
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'longSeats'">长边坐席</span>
                            </td>
                            <td>
                                <el-input v-model="longSeat" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'shortSeats'">短边坐席</span>
                            </td>
                            <td>
                                <el-input v-model="shortSeat" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td v-text-lbl="'seats'" align="right" class="tdBg" style="width: 130px">坐席</td>
                            <td>
                                {{ rectTotal }}
                                <span v-text-lbl="'personUnit'">人</span>
                            </td>
                        </tr>
                    </template>
                    <!-- 大礼堂 -->
                    <template v-if="deskType === 'big'">
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'podiumRowsNum'">主席台排数</span>
                            </td>
                            <td>
                                <el-input v-model="bigLeadRows" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'podiumEveryRowsNum'">主席台每排人数</span>
                            </td>
                            <td>
                                <el-input v-model="bigLeadRowNum" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'podiumStageOffNum'">主席台下排数</span>
                            </td>
                            <td>
                                <el-input v-model="bigCusRows" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" class="tdBg" style="width: 130px">
                                <em>*</em>
                                <span v-text-lbl="'podiumStageOffRowsNum'">主席台下每排人数</span>
                            </td>
                            <td>
                                <el-input v-model="bigCusRowNum" placeholder="" autocomplete="off" @change="onSubmit"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td v-text-lbl="'seats'" align="right" class="tdBg" style="width: 130px">坐席</td>
                            <td>
                                {{ bigTotal }}
                                <span v-text-lbl="'personUnit'">人</span>
                            </td>
                        </tr>
                    </template>
                </table>
                <!-- <el-form-item style="justify-content: center;margin: 10px;border-bottom:none;">
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
        </el-form-item> -->
            </el-form>
        </div>
    </div>
</template>

<script>
var uiC = null
var uId = ''
import $ from 'jquery'
import imgUrl from './images/close2.png'

export default {
    name: 'Seat',
    components: {},
    props: {},
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            uPng: require('./images/uSeat.png'),
            rectPng: require('./images/rectSeat.png'),
            circlePng: require('./images/circleSeat.png'),
            bigPng: require('./images/bigSeat.png'),
            // weizhi: require('./images/weizhi.png'),
            rectForm: {
                opId: '', // 当前被操作的对象的id
                rectTop: 0,
                rectRight: 0,
                rectBottom: 0,
                rectLeft: 0
            },
            deskType: '', // 桌子类型
            circleSeat: 8, // 圆桌坐席个数
            circleTop: '100px',
            circleLeft: '100px',
            longSeat: 10, // 长边坐席
            shortSeat: 1, // 短边坐席
            rectTotal: 11, // 长桌坐席总数
            bigLeadRows: 1, // 大礼堂主席台排数
            bigLeadRowNum: 5, // 大礼堂主席台排 坐的人数
            bigCusRows: 5, // 大礼堂主席台下面的排数
            bigCusRowNum: 8, // 大礼堂主席台下一排作的人数
            bigTotal: 45, // 大礼堂坐席总数
            realLongSeat: 10, // 实际上的长边坐席
            realShortSeat: 1, // 实际上的短边坐席
            realBigLeadRowNum: 5, // 实际上的 大礼堂主席台排 坐的人数
            doorAt: 'left' // 门的位置在哪条边上，默认在左边上
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        $('body').css({
            'overflow-y': 'unset'
        })
        $('.setForm').hide()

        if (localStorage.getItem('meetLayout')) {
            var meetLayout
            meetLayout = JSON.parse(localStorage.getItem('meetLayout'))
            uId = meetLayout.uId
            this.deskType = meetLayout.deskType
            this.$nextTick(() => {
                $('#center').append(unescape(meetLayout.seatHtml))
            })
            if (this.deskType === 'circle') {
                this.circleSeat = meetLayout.circleSeat
            } else if (this.deskType === 'rect' || this.deskType === 'utype') {
                this.longSeat = meetLayout.longSeat
                this.shortSeat = meetLayout.shortSeat
                this.realLongSeat = meetLayout.realLongSeat
                this.realShortSeat = meetLayout.realShortSeat
                this.rectTotal = meetLayout.rectTotal
            } else if (this.deskType === 'big') {
                this.bigLeadRows = meetLayout.bigLeadRows
                this.bigLeadRowNum = meetLayout.bigLeadRowNum
                this.bigCusRows = meetLayout.bigCusRows
                this.bigCusRowNum = meetLayout.bigCusRowNum
                this.realBigLeadRowNum = meetLayout.realBigLeadRowNum
                this.bigTotal = meetLayout.bigTotal
            }

            localStorage.removeItem('meetLayout') // 清除布局缓存

            $('.setForm').show('normal', function () {
                $('.setForm').css({ top: '140px', left: 'unset' })
            })

            this.$nextTick(() => {
                $('#' + uId).dblclick(function () {
                    $('.setForm').show('normal', function () {
                        $('.setForm').css({ top: '140px', left: 'unset' })
                    })
                })
            })
            this.handleBtn('#' + uId)
            // 门拖动事件
            $('.door').draggable({
                containment: 'parent',
                stop: function () {
                    var dom = $(this)[0]
                    var w = dom.clientWidth
                    var h = dom.clientHeight
                    var pw = dom.parentNode.clientWidth
                    var ph = dom.parentNode.clientHeight
                    var backGauge = {
                        left: dom.offsetLeft,
                        top: dom.offsetTop,
                        right: pw - dom.offsetLeft - w,
                        bottom: ph - dom.offsetTop - h
                    }
                    var min = 'left'
                    for (var key in backGauge) {
                        if (backGauge[key] - backGauge[min] < 0) {
                            min = key
                            this.doorAt = key
                        }
                    }
                    setTimeout(function () {
                        if (min === 'right') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style.left = parseInt(pw - 20 + 10) + 'px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        } else if (min === 'bottom') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style.top = parseInt(ph - 20 + 10) + 'px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'top') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style[min] = '-10px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'left') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style[min] = '-10px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        }
                    }, 0)
                }
            })
            // 鼠标进入增加一个删除的小图标
            $('.enterDiv').on('mouseenter', 'div.imgSeat', function () {
                var img = document.createElement('img')
                img.setAttribute('id', 'newImgDel')
                img.style.position = 'absolute'
                img.style.width = '30px'
                img.style.height = '30px'
                img.style.right = '-10px'
                img.style.top = '-10px'
                img.src = imgUrl
                $(this).append(img)
            })
            // 鼠标离开小图标消失
            $('.enterDiv').on('mouseleave', '.imgSeat', function () {
                $('#newImgDel').remove()
            })
            // 节点小图标的单击事件
            $('.enterDiv').on('click', '#newImgDel', function () {
                $(this).parent().remove()
                if (_this.deskType === 'circle') {
                    --_this.circleSeat
                } else if (_this.deskType === 'rect' || _this.deskType === 'utype') {
                    --_this.rectTotal
                    if ($(this).parent().attr('type') === 'short') {
                        // --_this.shortSeat
                        --_this.realShortSeat
                    } else if ($(this).parent().attr('type') === 'long') {
                        // --_this.longSeat
                        --_this.realLongSeat
                    }
                    console.log('实际数量', _this.realLongSeat, _this.realShortSeat)
                }
                if (_this.deskType === 'big') {
                    --_this.bigTotal
                    if ($(this).parent().attr('type') === 'lead') {
                        --_this.realBigLeadRowNum
                    } else if ($(this).parent().attr('type') === 'cus') {
                        // --_this.longSeat
                        // --_this.realLongSeat
                    }
                }
            })
            // 删除节点事件
            $('#deleteNode').bind('click', function () {
                $('#' + uId).remove()
                $('.setForm').hide()
            })
        }

        var _this = this
        this.$nextTick(() => {
            $('#' + uId).dblclick(function () {
                $('.setForm').show('normal', function () {
                    $('.setForm').css({ top: '140px', left: 'unset' })
                })
            })
        })

        // 设置右侧为存放区
        var i = 0

        // 左侧点击
        $('#left ul li>img').click(function (e) {
            _this.circleSeat = 8 // 圆桌坐席个数
            _this.longSeat = 10 // 长边坐席
            _this.shortSeat = 1 // 短边坐席
            _this.rectTotal = 11 // 长桌坐席总数
            _this.bigLeadRows = 1 // 大礼堂主席台排数
            _this.bigLeadRowNum = 5 // 大礼堂主席台排 坐的人数
            _this.bigCusRows = 5 // 大礼堂主席台下面的排数
            _this.bigCusRowNum = 8 // 大礼堂主席台下一排作的人数
            _this.bigTotal = 45 // 大礼堂坐席总数
            _this.realLongSeat = 10 // 实际上的长边坐席
            _this.realShortSeat = 1 // 实际上的短边坐席
            _this.realBigLeadRowNum = 5 // 实际上的 大礼堂主席台排 坐的人数
            $('#center .enterDiv').remove()
            i++
            const type = $(e.target).attr('type')
            _this.$nextTick(() => {
                _this.deskType = $(e.target).attr('type')
            })
            var id = type + i
            uiC = id
            uId = id
            if (type === 'rect') {
                const arr = [_this.longSeat, _this.shortSeat]
                _this.createCircle('rect', uiC, uId, arr)
            } else if (type === 'circle') {
                _this.createCircle('circle', uiC, uId, _this.circleSeat)
            } else if (type === 'utype') {
                const arr = [_this.longSeat, _this.shortSeat]
                _this.createCircle('utype', uiC, uId, arr)
            } else if (type === 'big') {
                const arr = [_this.bigLeadRows, _this.bigLeadRowNum, _this.bigCusRows, _this.bigCusRowNum]
                _this.createCircle('big', uiC, uId, arr)
            }

            // 门拖动事件
            $('.door').draggable({
                containment: 'parent',
                stop: function () {
                    var dom = $(this)[0]
                    var w = dom.clientWidth
                    var h = dom.clientHeight
                    var pw = dom.parentNode.clientWidth
                    var ph = dom.parentNode.clientHeight
                    var backGauge = {
                        left: dom.offsetLeft,
                        top: dom.offsetTop,
                        right: pw - dom.offsetLeft - w,
                        bottom: ph - dom.offsetTop - h
                    }
                    var min = 'left'
                    for (var key in backGauge) {
                        if (backGauge[key] - backGauge[min] < 0) {
                            min = key
                            this.doorAt = key
                        }
                    }
                    setTimeout(function () {
                        if (min === 'right') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style.left = parseInt(pw - 20 + 10) + 'px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        } else if (min === 'bottom') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style.top = parseInt(ph - 20 + 10) + 'px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'top') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style[min] = '-10px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'left') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style[min] = '-10px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        }
                    }, 0)
                }
            })

            $('.setForm').show('normal', function () {
                $('.setForm').css({ top: '140px', left: 'unset' })
            })
            // 默认拖过来显示编辑弹窗
            // $('#' + id).resizable({
            //     containment: '#center',
            //     handles: 'n, e, s, w, ne, se, sw, nw' // 可选值 n, e, s, w, ne, se, sw, nw, all
            // })
            $('#' + id).dblclick(function () {
                $('.setForm').show('normal', function () {
                    $('.setForm').css({ top: '140px', left: 'unset' })
                })
            })
            _this.handleBtn('#' + id)

            // 鼠标进入增加一个删除的小图标
            $('.enterDiv').on('mouseenter', 'div.imgSeat', function () {
                var img = document.createElement('img')
                img.setAttribute('id', 'newImgDel')
                img.style.position = 'absolute'
                img.style.width = '30px'
                img.style.height = '30px'
                img.style.right = '-10px'
                img.style.top = '-10px'
                img.src = imgUrl
                $(this).append(img)
            })
            // 鼠标离开小图标消失
            $('.enterDiv').on('mouseleave', '.imgSeat', function () {
                $('#newImgDel').remove()
            })
            // 节点小图标的单击事件
            $('.enterDiv').on('click', '#newImgDel', function () {
                $(this).parent().remove()
                if (_this.deskType === 'circle') {
                    --_this.circleSeat
                } else if (_this.deskType === 'rect' || _this.deskType === 'utype') {
                    --_this.rectTotal
                    if ($(this).parent().attr('type') === 'short') {
                        // --_this.shortSeat
                        --_this.realShortSeat
                    } else if ($(this).parent().attr('type') === 'long') {
                        // --_this.longSeat
                        --_this.realLongSeat
                    }
                    console.log('实际数量', _this.realLongSeat, _this.realShortSeat)
                }
                if (_this.deskType === 'big') {
                    --_this.bigTotal
                    if ($(this).parent().attr('type') === 'lead') {
                        --_this.realBigLeadRowNum
                    } else if ($(this).parent().attr('type') === 'cus') {
                        // --_this.longSeat
                        // --_this.realLongSeat
                    }
                }
            })
        })

        $('.setForm').draggable({ containment: '#center', scroll: true })
        // 删除节点事件
        $('#deleteNode').bind('click', function () {
            $('#' + uId).remove()
            $('.setForm').hide()
        })
    },
    methods: {
        hideForm() {
            $('.setForm').hide()
        },
        // 立即创建
        onSubmit() {
            if (this.deskType === 'circle') {
                // 圆型桌
                if (this.circleSeat) {
                    this.createCircle(this.deskType, uiC, uId, this.circleSeat)
                }
            } else if (this.deskType === 'rect' || this.deskType === 'utype') {
                // 长型桌或者U型桌
                if (this.longSeat || this.shortSeat) {
                    this.rectTotal = parseInt(this.longSeat) + parseInt(this.shortSeat)
                    const arr = [this.longSeat ? this.longSeat : 0, this.shortSeat ? this.shortSeat : 0]
                    this.createCircle(this.deskType, uiC, uId, arr)
                    this.realLongSeat = this.longSeat
                    this.realShortSeat = this.shortSeat
                }
            } else if (this.deskType === 'big') {
                // 大礼堂
                if (this.bigLeadRows || this.bigLeadRowNum || this.bigCusRows || this.bigCusRowNum) {
                    this.bigTotal = parseInt(this.bigLeadRows) * parseInt(this.bigLeadRowNum) + parseInt(this.bigCusRows) * parseInt(this.bigCusRowNum)
                    const arr = [this.bigLeadRows ? this.bigLeadRows : 0, this.bigLeadRowNum ? this.bigLeadRowNum : 0, this.bigCusRows ? this.bigCusRows : 0, this.bigCusRowNum ? this.bigCusRowNum : 0]
                    this.createCircle(this.deskType, uiC, uId, arr)
                    this.realBigLeadRowNum = this.bigLeadRowNum * this.bigLeadRows
                }
            }
        },
        createCircle(type, ui, id, seatNum) {
            if (type === 'circle') {
                // 圆型桌
                this.createCircleCircle(...arguments)
            } else if (type === 'rect') {
                // 长型桌
                this.createCircleRect(...arguments)
            } else if (type === 'utype') {
                // U型桌
                this.createCircleUtype(...arguments)
            } else if (type === 'big') {
                // 大礼堂
                this.createCircleBig(...arguments)
            }
        },
        // 创建圆型桌
        createCircleCircle(type, ui, id, seatNum) {
            this.createCircleBasis(id)
            // 添加中心桌
            const centerTable = `<div id="centerTable"></div>`
            $('#' + id).append(centerTable)
            $('#centerTable').css({ margin: '60px', position: 'relative', 'box-sizing': 'border-box', 'background-color': '#EC8423', 'border-radius': '50%', width: parseInt(36 * seatNum) + 'px', height: parseInt(36 * seatNum) + 'px' })
            // 处理座位
            function generateArray(num) {
                let result = []
                // 添加奇数部分：从最大的奇数开始，递减
                for (let i = num; i >= 1; i--) {
                    if (i % 2 !== 0) {
                        result.unshift(i)
                    }
                }
                // 添加偶数部分：从最小的偶数开始，递增
                for (let i = 1; i <= num; i++) {
                    if (i % 2 === 0) {
                        result.unshift(i)
                    }
                }
                result.reverse()
                console.log('result', result)

                return result
            }
            var arr = generateArray(seatNum)
            console.log('圆型桌arr', arr)
            // arr = [1, 3, 5, 7, 8, 6, 4, 2]

            var yNum = (36 * seatNum) / 2 + 30
            this.circleLeft = this.circleTop = 36 * seatNum - yNum + 'px'
            // var degNum = parseInt(360 / seatNum)
            var degNum = Math.round((360 / seatNum) * 100) / 100 // 细化旋转角度，更为均分
            for (var c = 0; c < seatNum; c++) {
                const deg = (c * degNum) - 135
                // const img = '<div id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;transform:rotate(' + deg + 'deg) translateY(' + parseInt(yNum + 1) + 'px);top:' + this.circleTop + ';left:' + this.circleLeft + ';">' + parseInt(c + 1) + '</div>'
                const img = '<div id="imgSeat-' + (arr[c] - 1) + '" class="imgSeat imgSeat-' + (arr[c] - 1) + '" style="background: #666666;border-radius: 6px;transform:rotate(' + deg + 'deg) translateY(' + parseInt(yNum + 1) + 'px);top:' + this.circleTop + ';left:' + this.circleLeft + ';">' + arr[c] + '</div>'
                $('#centerTable')[0].innerHTML += img
            }
        },
        // 创建长型桌
        createCircleRect(type, ui, id, seatNum) {
            seatNum[0] = parseInt(seatNum[0])
            seatNum[1] = parseInt(seatNum[1])
            var lnum = parseInt(seatNum[0] / 2) + parseInt(seatNum[0] % 2)
            this.createCircleBasis(id)
            // 添加中心桌
            const centerTable = `<div id="centerTable"></div>`
            $('#' + id).append(centerTable)
            $('#centerTable').css({ margin: '60px', 'margin-left': '0', position: 'relative', 'border-radius': '6px', border: '1px solid #fff', 'background-color': '#EC8423', width: 82 * lnum + 'px', height: parseInt(89 * seatNum[1] + 29) + 'px' })
            // 处理短边坐席样式
            for (let c = 0; c < seatNum[1]; c++) {
                const img = '<div type="short" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;right:-61px;bottom:' + parseInt(c * 89 + 29) + 'px;">' + parseInt(c + 1) + '</div>'
                $('#centerTable')[0].innerHTML += img
            }
            // 生成数组
            function generateArray(num, start) {
                let topArr = []
                let bottomArr = []
                // 添加奇数部分：从 num 开始，递减到 start
                for (let i = num; i > start; i--) {
                    if (i % 2 !== 0) { // 如果是奇数
                        topArr.push(i)
                    }
                }

                // 添加偶数部分：从 start + 1 开始，递增到 num
                for (let i = start + 1; i <= num; i++) {
                    if (i % 2 === 0) { // 如果是偶数
                        bottomArr.push(i)
                    }
                }
                topArr.reverse()
                return [topArr, bottomArr]
            }
            var temp = generateArray(seatNum[0] + seatNum[1], seatNum[1])
            let topArr = temp[0]
            let bottomArr = temp[1]

            let i = 0
            let j = 0
            // 处理长边坐席样式
            for (let c = seatNum[1]; c < parseInt(lnum + seatNum[1]); c++) { // 下边
                const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;bottom:-61px;right:' + parseInt((c - seatNum[1]) * 78 + 18) + 'px;">' + bottomArr[i] + '</div>'
                $('#centerTable')[0].innerHTML += img
                i += 1
            }
            for (let c = lnum + seatNum[1]; c < seatNum[0] + seatNum[1]; c++) { // 上边
                const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;top:-61px;right:' + parseInt((c - (lnum + seatNum[1])) * 78 + 18) + 'px;">' + topArr[j] + '</div>'
                $('#centerTable')[0].innerHTML += img
                j += 1
            }
        },
        // 创建U型桌
        createCircleUtype(type, ui, id, seatNum) {
            seatNum[0] = parseInt(seatNum[0])
            seatNum[1] = parseInt(seatNum[1])
            var lnum2 = parseInt(seatNum[0] / 2) + parseInt(seatNum[0] % 2)

            this.createCircleBasis(id)
            // 添加中心桌
            const centerTable = `<div id="centerTable"></div>`
            $('#' + id).append(centerTable)
            $('#centerTable').css({ margin: '60px', 'margin-left': '0', position: 'relative', 'border-radius': '6px', border: '1px solid #fff', 'background-color': '#EC8423', width: 82 * lnum2 + 'px', height: parseInt(89 * seatNum[1] + 29) + 'px' })
            const inerDiv = '<div style="position:absolute;background:#fff;left:0;top:45px;right:45px;bottom:45px;"></div>'
            $('#centerTable')[0].innerHTML += inerDiv
            // 处理短边坐席样式
            for (let c = 0; c < seatNum[1]; c++) {
                const img = '<div type="short" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;right:-61px;bottom:' + parseInt(c * 89 + 29) + 'px;">' + parseInt(c + 1) + '</div>'
                $('#centerTable')[0].innerHTML += img
            }
            function generateArray(num, start) {
                let topArr = []
                let bottomArr = []
                // 添加奇数部分：从 num 开始，递减到 start
                for (let i = num; i > start; i--) {
                    if (i % 2 !== 0) { // 如果是奇数
                        topArr.push(i)
                    }
                }

                // 添加偶数部分：从 start + 1 开始，递增到 num
                for (let i = start + 1; i <= num; i++) {
                    if (i % 2 === 0) { // 如果是偶数
                        bottomArr.push(i)
                    }
                }
                topArr.reverse()
                return [topArr, bottomArr]
            }
            var temp = generateArray(seatNum[0] + seatNum[1], seatNum[1])
            let topArr = temp[0]
            let bottomArr = temp[1]

            // 处理长边坐席样式
            let i = 0
            for (let c = seatNum[1]; c < parseInt(lnum2 + seatNum[1]); c++) { // 下边 偶数
                // const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;bottom:-61px;right:' + parseInt((c - seatNum[1]) * 78 + 18) + 'px;">' + parseInt(c + 1) + '</div>'
                // $('#centerTable')[0].innerHTML += img
                const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;bottom:-61px;right:' + parseInt((c - seatNum[1]) * 78 + 18) + 'px;">' + bottomArr[i] + '</div>'
                $('#centerTable')[0].innerHTML += img
                i += 1
            }
            let j = 0
            for (let c = lnum2 + seatNum[1]; c < seatNum[0] + seatNum[1]; c++) { // 上边 奇数
                // const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;top:-61px;right:' + parseInt((c - (lnum2 + seatNum[1])) * 78 + 18) + 'px;">' + parseInt(c + 1) + '</div>'
                // $('#centerTable')[0].innerHTML += img
                const img = '<div type="long" id="imgSeat-' + c + '" class="imgSeat imgSeat-' + c + '" style="background: #666666;border-radius: 6px;top:-61px;right:' + parseInt((c - (lnum2 + seatNum[1])) * 78 + 18) + 'px;">' + topArr[j] + '</div>'
                $('#centerTable')[0].innerHTML += img
                j += 1
            }
        },
        // 创建大礼堂
        createCircleBig(type, ui, id, seatNum) {
            seatNum[0] = parseInt(seatNum[0])
            seatNum[1] = parseInt(seatNum[1])
            seatNum[2] = parseInt(seatNum[2])
            seatNum[3] = parseInt(seatNum[3])

            this.createCircleBasis(id)
            // 生成数组
            function generateArray(num) {
                let result = []
                // 添加奇数部分：从最大的奇数开始，递减
                for (let i = num; i >= 1; i--) {
                    if (i % 2 !== 0) {
                        result.push(i)
                    }
                }
                // 添加偶数部分：从最小的偶数开始，递增
                for (let i = 1; i <= num; i++) {
                    if (i % 2 === 0) {
                        result.push(i)
                    }
                }
                result.reverse()
                return result
            }
            const arr = generateArray(seatNum[1])
            // 添加主席台
            for (var m = 0; m < seatNum[0]; m++) {
                const div2 = `<div id="lead${m}${id}" style="position:relative;height:56px;border-radius:6px;border:1px solid #fff;background-color:#EC8423;margin-top:80px;width:${82 * this.bigLeadRowNum}px"></div>`
                $('#' + id).append(div2)
                for (let c = 0; c < seatNum[1]; c++) {
                    console.log('c', c)

                    // const img = `<div type="lead" id="imgSeat-L-${m}-${c}" class="imgSeat imgSeatLead imgSeat-L-'${c}" style="background: #666666;border-radius: 6px;bottom:56px;right:${parseInt(c * 78 + 18)}px;">${parseInt(c + 1)}q</div>`
                    const img = `<div type="lead" id="imgSeat-L-${m}-${c}" class="imgSeat imgSeatLead imgSeat-L-'${c}" style="background: #666666;border-radius: 6px;bottom:56px;right:${parseInt(c * 78 + 18)}px;">${arr[c]}</div>`
                    $('#lead' + m + id)[0].innerHTML += img
                }
            }
            /*
             现有一个需求，给一个正整数，通过循环得出指定要求的数组。
             例如，num=5, 结果数组为[5,3,1,2,4]。
              num=6， 结果数组为 [5,3,1,2,4,6],
              使用js语法实现
            */
            // 添加观众席 使用table
            var tab = document.createElement('table')
            tab.style.borderSpacing = '10px'
            tab.style.marginTop = '50px'
            $('#' + id).append(tab)

            for (let i = 0; i < seatNum[2]; i++) {
                var tr = document.createElement('tr')
                tab.appendChild(tr)
                for (let j = 0; j < seatNum[3]; j++) {
                    var td = document.createElement('td')
                    td.style.position = 'relative'
                    td.style.width = '60px'
                    td.style.height = '60px'
                    const img = '<div type="cus" id="imgSeat-' + i + '-' + j + '" class="imgSeat imgSeatCus imgSeat-' + i + '-' + j + '" style="background: #666666;border-radius: 6px;position:unset;">' + parseInt(i + 1) + '-' + parseInt(j + 1) + '</div>'
                    td.innerHTML = img
                    tr.appendChild(td)
                }
            }
            this.doorDrag()
        },
        // 生成基础元素
        createCircleBasis(id) {
            const enterDiv = `<div class="enterDiv" id="${id}" style="display:inline-flex;flex-direction:column;justify-content:center; align-items:center;padding:30px;"></div>`
            $('#center').append(enterDiv)
            $('#' + id).html('')
            // 添加门框
            const divW = `<div class="divW" style="position:absolute;border:10px solid #ddd;width:100%;height:100%"><div class="door" style="position:absolute;width:20px;height:90px;background:#fff;top:30px;left:-10px;border-top: 1px solid #333;border-bottom: 1px solid #333;"></div></div>`
            $('#' + id)[0].innerHTML += divW
        },
        // 门拖动事件
        doorDrag() {
            $('.door').draggable({
                containment: 'parent',
                stop: function () {
                    var dom = $(this)[0]
                    var w = dom.clientWidth
                    var h = dom.clientHeight
                    var pw = dom.parentNode.clientWidth
                    var ph = dom.parentNode.clientHeight
                    var backGauge = {
                        left: dom.offsetLeft,
                        top: dom.offsetTop,
                        right: pw - dom.offsetLeft - w,
                        bottom: ph - dom.offsetTop - h
                    }
                    var min = 'left'
                    for (var key in backGauge) {
                        if (backGauge[key] - backGauge[min] < 0) {
                            min = key
                            this.doorAt = key
                        }
                    }
                    setTimeout(function () {
                        if (min === 'right') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style.left = parseInt(pw - 20 + 10) + 'px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        } else if (min === 'bottom') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style.top = parseInt(ph - 20 + 10) + 'px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'top') {
                            dom.style.borderTop = 'none'
                            dom.style.borderRight = '1px solid #333'
                            dom.style.borderBottom = 'none'
                            dom.style.borderLeft = '1px solid #333'
                            dom.style[min] = '-10px'
                            dom.style.width = '90px'
                            dom.style.height = '20px'
                        } else if (min === 'left') {
                            dom.style.borderTop = '1px solid #333'
                            dom.style.borderRight = 'none'
                            dom.style.borderBottom = '1px solid #333'
                            dom.style.borderLeft = 'none'
                            dom.style[min] = '-10px'
                            dom.style.width = '20px'
                            dom.style.height = '90px'
                        }
                    }, 0)
                }
            })
        },
        handleBtn(id) {
            $(id).bind('mousedown', function (e) {
                $(document).bind('contextmenu', function () {
                    return false
                })
                if (e.which === 3) {
                    // 鼠标点击了右键
                    $('.dropdown-menu').show()
                    $('.dropdown-menu').css({
                        top: e.pageY,
                        left: e.pageX
                    })
                    return false
                }
            })

            $(document).bind('click', function () {
                $('.dropdown-menu').hide()
                // 解绑
                // $('.dropdown-menu').find('#deleteNode').unbind()
            })
        },
        closeSeat() {
            setTimeout(() => {
                window.close()
                // 关闭页面
            }, 10)
        },
        saveSeat() {
            var seatObj = {}
            if (this.deskType === 'circle') {
                seatObj = {
                    deskType: 'circle',
                    deskName: '圆型桌',
                    circleSeat: this.circleSeat,
                    seatHtml: escape($('.enterDiv')[0].outerHTML),
                    uId: uId,
                    deskDesc: '圆型桌-' + this.circleSeat + '人',
                    doorAt: this.doorAt
                }
            } else if (this.deskType === 'rect' || this.deskType === 'utype') {
                seatObj = {
                    deskType: this.deskType,
                    deskName: this.deskType === 'rect' ? '长型桌' : 'U型桌',
                    longSeat: this.longSeat,
                    shortSeat: this.shortSeat,
                    realLongSeat: this.realLongSeat,
                    realShortSeat: this.realShortSeat,
                    rectTotal: this.rectTotal,
                    seatHtml: escape($('.enterDiv')[0].outerHTML),
                    uId: uId,
                    deskDesc: this.deskType === 'rect' ? '长型桌-长边共' + this.realLongSeat + '人，短边共' + this.realShortSeat + '人' : 'U型桌-长边共' + this.realLongSeat + '人，短边共' + this.realShortSeat + '人',
                    doorAt: this.doorAt
                }
            } else if (this.deskType === 'big') {
                seatObj = {
                    deskType: 'big',
                    deskName: '大礼堂',
                    bigTotal: this.bigTotal,
                    realBigLeadRowNum: this.realBigLeadRowNum, // 大礼堂领导排实际座位人数
                    bigLeadRows: this.bigLeadRows,
                    bigLeadRowNum: this.bigLeadRowNum,
                    bigCusRows: this.bigCusRows,
                    bigCusRowNum: this.bigCusRowNum,
                    seatHtml: escape($('.enterDiv')[0].outerHTML),
                    uId: uId,
                    deskDesc: '大礼堂-主席台' + this.bigLeadRows + '排共' + this.realBigLeadRowNum + '人，台下' + this.bigCusRows + '排共' + parseInt(this.bigTotal - this.realBigLeadRowNum) + '人',
                    doorAt: this.doorAt
                }
            }
            setTimeout(() => {
                window.close()
                // 关闭页面
            }, 10)
            // 传递数据
            window.opener.getData(seatObj)
        },

        htmlEncode(str) {
            var s = ''
            if (str.length === 0) return ''
            s = str.replace(/&/g, '>')
            s = s.replace(/</g, '<')
            s = s.replace(/>/g, '>')
            s = s.replace(/ /g, ' ')
            s = s.replace(/\'/g, "'")
            s = s.replace(/\"/g, "'")
            s = s.replace(/\n/g, '<br>')
            return s
        },

        // 解码
        htmlDecode(str) {
            var s = ''
            if (str.length === 0) return ''
            s = str.replace(/>/g, '&')
            s = s.replace(/</g, '<')
            s = s.replace(/>/g, '>')
            s = s.replace(/ /g, ' ')
            s = s.replace(/'/g, "'")
            s = s.replace(/"/g, '"')
            s = s.replace(/<br>/g, '\n')
            return s
        }
    }
}
</script>
<style>
body {
    overflow-y: unset;
}
.imgSeat {
    position: absolute;
    /* width: 42px; */
    /* height:  42px; */
    width: 60px;
    height: 60px;
    /* padding-top: 5px; */
    /* line-height: 40px; */
    text-align: center;
    color: #fff;
    /* z-index: -1; */
    /* overflow: hidden; */
    font-size: 16px;
    padding: 7px 0;
    font-weight: bold;
}
.enterDiv {
    position: relative;
    top: 150px;
    margin: 0 100px 150px;
}
</style>
<style scoped lang="scss">
td {
    width: 60px;
    height: 60px;
}
.mt12 {
    margin-top: 12px;
}
.headBtn {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 60px;
    padding: 0 10px;
    box-sizing: border-box;
    background: #354052;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
}
.seat-main {
    display: flex;
    padding-top: 60px;
    width: 100%;
    height: 100%;
}
ul,
li {
    list-style: none;
    margin: 0;
    padding: 0;
}
ul > li.left-li {
    font-size: var(--portalFontSize14);
    color: #666;
    margin-bottom: 20px;
    padding: 30px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    & > img:hover {
        cursor: pointer;
    }
}
ul > li.left-li:last-child {
    margin-bottom: 60px;
}
.rect {
    width: 640px;
    height: 160px;
    background: #ec8423;
}
.circle {
    width: 240px;
    height: 240px;
    border-radius: 50%;
    background: #ec8423;
}
.utype {
    width: 240px;
    height: 320px;
    line-height: 320px;
    background: #ec8423;
    border-radius: 0 0 40% 40%;
}
.left {
    background: #f3f4f4;
    height: 100%;
    width: 210px;
    box-sizing: border-box;
    overflow-y: auto;
    position: fixed;
    z-index: 10;
}
.left::-webkit-scrollbar {
    display: none;
}
.center {
    // width: 100vw;
    height: 100vh;
    padding-left: 210px;
}
.dropdown-menu {
    width: 160px;
    display: none;
    position: fixed;
    z-index: 999999;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: var(--portalFontSize14);
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    li {
        a {
            padding: 5px 20px;
            line-height: 1.5;
            white-space: nowrap;
            color: #333;
        }
        &:hover {
            background: #f5f5f5;
        }
    }
}
.setForm {
    height: 100%;
    position: absolute;
    right: 50px;
    top: 140px;
    width: 350px;
    height: 400px;
    background: #fff;
    box-sizing: border-box;
    overflow-y: hidden;
    border-radius: 3px;
    -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 3px #909399;
}
.el-form-item {
    display: flex;
    padding: 0 10px 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
}
.attr_title {
    font-size: var(--portalFontSize14);
    height: 44px;
    background: #f8f8f8;
    position: relative;
    padding: 0 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
table {
    border-collapse: collapse;
    width: 320px;
    margin: auto;
}
table tr td {
    border: 1px solid #e2e2e2;
    padding: 5px;
    height: 40px;
    color: #555;
    font-size: var(--portalFontSize14);
    line-height: 30px;
    width: unset;
}
table tr td em {
    color: red;
}

.imgSeat {
    position: absolute;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
}
</style>
